import React from "react";
import { FormattedMessage } from "react-intl";
import formatCurrency from "../../helpers/formatCurrency";
import { SummaryButton } from "@hooplab/ui-components";
import { useCurrentLangContext } from "../../hooks/useCurrentLang";

interface CartButtonProps {
  ticketSize: number;
  addonSize: number;
  loading: boolean;
  sum: number;
  onClick: () => void;
}

const CartButton: React.FC<CartButtonProps> = ({
  ticketSize,
  addonSize,
  loading,
  sum,
  onClick,
}) => {
  const {
    provided: {
      currentLocale: { name: localeName },
    },
  } = useCurrentLangContext()!;
  return (
    <>
      <SummaryButton
        infoText={
          <FormattedMessage
            id="components.Cart.CartButton.youHaveSelected"
            defaultMessage="You have selected"
          />
        }
        toTopText={
          <FormattedMessage id="components.Cart.CartButton.goUpButton" defaultMessage="Go up" />
        }
        formattedSummary={
          <FormattedMessage
            id="components.Cart.CartButton.ticketAndPrice"
            defaultMessage="{total, selectordinal, =0 {} other {<s>{ticketSize, plural, =0 {} one {# ticket} other {# tickets}}</s><s>{addonSize, plural, =0 {} one {, # add-on} other {, # add-ons}}</s>}}"
            values={{
              s: (chunks: React.ReactNode) => (
                <span style={{ whiteSpace: "nowrap" }}>{chunks}</span>
              ),
              ticketSize: ticketSize,
              addonSize: addonSize,
              total: addonSize + ticketSize,
              price: formatCurrency(sum / 100, localeName),
            }}
          />
        }
        buttonText={
          <FormattedMessage id="components.Cart.CartButton.proceed" defaultMessage="Proceed" />
        }
        loading={loading}
        inactiveText={
          <FormattedMessage
            id="components.Cart.CartButton.selectATicket"
            defaultMessage="Select a ticket to continue"
          />
        }
        onClick={onClick}
        isActive={ticketSize > 0}
      />
    </>
  );
};

export default CartButton;
